import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BeheerdersportaalSidebar from '../components/BeheerdersportaalSidebar';
import api from '../components/api';
import '../css/ProjectPlanningAdmin.css';
import '../css/PageWithSidebar.css';

const ProjectPlanningDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      const res = await api.get(`/api/planning/admin/projects/${id}/bookings`);
      setData(res.data);
    } catch (err) {
      console.error('Error fetching bookings:', err);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const handleDelete = async (bookingId) => {
    if (!window.confirm('Weet u zeker dat u deze inschrijving wilt verwijderen?')) return;
    try {
      await api.delete(`/api/planning/admin/bookings/${bookingId}`);
      fetchData();
    } catch (err) {
      alert('Fout bij verwijderen');
    }
  };

  if (loading) {
    return <BeheerdersportaalSidebar><div className="pp-admin"><p>Laden...</p></div></BeheerdersportaalSidebar>;
  }

  if (!data) {
    return <BeheerdersportaalSidebar><div className="pp-admin"><p>Project niet gevonden</p></div></BeheerdersportaalSidebar>;
  }

  const { project, slots } = data;
  const allSlots = Object.values(slots);
  const totalBooked = allSlots.reduce((sum, s) => sum + s.ingeschreven.length, 0);
  const totalWaitlist = allSlots.reduce((sum, s) => sum + s.wachtlijst.length, 0);

  return (
    <BeheerdersportaalSidebar>
      <div className="pp-admin">
        <div className="pp-admin-header">
          <div>
            <button className="pp-btn-back" onClick={() => navigate('/planning-admin')}>&larr; Terug</button>
            <h1>{project.titel.nl}</h1>
            <p className="pp-project-slug">Link: https://www.vvepolderzicht.nl/planning/{project.slug}</p>
          </div>
        </div>

        <div className="pp-stats">
          <div className="pp-stat-card"><div className="pp-stat-number">{totalBooked}</div><div className="pp-stat-label">Ingeschreven</div></div>
          <div className="pp-stat-card"><div className="pp-stat-number">{totalWaitlist}</div><div className="pp-stat-label">Wachtlijst</div></div>
          <div className="pp-stat-card"><div className="pp-stat-number">{totalBooked + totalWaitlist}</div><div className="pp-stat-label">Totaal</div></div>
        </div>

        {allSlots.map(slot => (
          <div key={slot.slotId} className="pp-slot-section">
            <h2>{slot.label.nl}</h2>
            <p className="pp-slot-capacity">{slot.ingeschreven.length} / {slot.maxPlekken} plekken bezet</p>

            {slot.ingeschreven.length > 0 ? (
              <div className="pp-table-responsive">
                <table className="pp-table">
                  <thead><tr><th>Huisnr</th><th>Naam</th><th>E-mail</th><th>Telefoon</th><th>Ingeschreven op</th><th></th></tr></thead>
                  <tbody>
                    {slot.ingeschreven.map(b => (
                      <tr key={b._id}>
                        <td><strong>{b.huisnummer}</strong></td>
                        <td>{b.naam}</td>
                        <td><a href={`mailto:${b.email}`}>{b.email}</a></td>
                        <td>{b.telefoon || '-'}</td>
                        <td>{new Date(b.registeredAt).toLocaleString('nl-NL')}</td>
                        <td><button className="pp-btn-delete" onClick={() => handleDelete(b._id)}>Verwijder</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="pp-no-bookings">Nog geen inschrijvingen</p>
            )}

            {slot.wachtlijst.length > 0 && (
              <>
                <h3 className="pp-waitlist-title">Wachtlijst ({slot.wachtlijst.length})</h3>
                <div className="pp-table-responsive">
                  <table className="pp-table pp-table-waitlist">
                    <thead><tr><th>Huisnr</th><th>Naam</th><th>E-mail</th><th>Telefoon</th><th>Ingeschreven op</th><th></th></tr></thead>
                    <tbody>
                      {slot.wachtlijst.map(b => (
                        <tr key={b._id}>
                          <td><strong>{b.huisnummer}</strong></td>
                          <td>{b.naam}</td>
                          <td><a href={`mailto:${b.email}`}>{b.email}</a></td>
                          <td>{b.telefoon || '-'}</td>
                          <td>{new Date(b.registeredAt).toLocaleString('nl-NL')}</td>
                          <td><button className="pp-btn-delete" onClick={() => handleDelete(b._id)}>Verwijder</button></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </BeheerdersportaalSidebar>
  );
};

export default ProjectPlanningDetail;
